module.exports = __webpack_public_path__ + "static/media/aqua_05.064075d3.JPG";